import React, { useState } from 'react';

const ForgotPasswordForm = ({ onNavigate, onResetPassword }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Por favor ingresa tu email');
      return;
    }

    // Aquí iría la lógica para enviar el email de recuperación
    // Por ahora simulamos el envío
    setTimeout(() => {
      setMessage(`Se ha enviado un enlace de recuperación a ${email}`);
      setEmail('');
    }, 1000);
  };

  return (
    <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md mt-10">
      <h2 className="text-2xl font-bold mb-6 text-center">Recuperar contraseña</h2>
      <p className="text-gray-600 mb-6 text-center">
        Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
      </p>

      {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
      {message && <p className="text-green-600 mb-4 text-center">{message}</p>}

      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition-colors mb-4 text-lg"
        >
          Enviar enlace de recuperación
        </button>
      </form>

      <div className="text-center">
        <button
          onClick={() => onNavigate('login')}
          className="text-purple-600 hover:text-purple-800 font-medium text-base"
        >
          Volver al inicio de sesión
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;